
export enum AppView {
  DASHBOARD = 'DASHBOARD',
  DONNA_WORKSPACE = 'DONNA_WORKSPACE',
  GRAPHIFY_DEV_MAP = 'GRAPHIFY_DEV_MAP',
  BOT_DEMO = 'BOT_DEMO',
  ROI_CALCULATOR = 'ROI_CALCULATOR',
  PIPELINE = 'PIPELINE',
  WORKFLOW_MONITOR = 'WORKFLOW_MONITOR',
  SALES_PLAYBOOK = 'SALES_PLAYBOOK',
  AFFILIATE_PORTAL = 'AFFILIATE_PORTAL',
  INTEGRATIONS = 'INTEGRATIONS',
  DEEP_AUDIT = 'DEEP_AUDIT',
  BRAIN_UPLOAD = 'BRAIN_UPLOAD'
}

export type BotPersonality = 'SALES_HUNTER' | 'CUSTOMER_SUPPORT' | 'TECH_EXPERT';

export interface Lead {
  id: string;
  name: string;
  company: string;
  status: 'New' | 'Qualified' | 'Audit Booked' | 'Demo Booked' | 'Proposal' | 'Closed Won' | 'Contacted';
  value: number; // Estimated Contract Value
  notes: string;
  email?: string;
}

export interface BotStatus {
  id: string;
  name: string;
  type: 'PROXY' | 'WORKFLOW' | 'STORAGE';
  status: 'Online' | 'Maintenance' | 'Error';
  version: string;
  cpuLoad: number; // in %
  memoryUsage: string; // e.g. "2.4 GB"
  uptime: string;
}

export interface AuditResult {
  score: number;
  summary: string;
  opportunities: string[];
  risks: string[];
  estimatedSavings: string;
}

export interface WorkflowNode {
    id: string;
    name: string;
    category: string;
    status: string;
    lastRun: string;
    executions: number;
    avgTime: string;
}
